<script setup lang="ts">
import { useHead } from '@unhead/vue'
import CallToAction from '../components/CallToActionContactUs.vue'
import { subjects } from '../constants/customerServiceSubjects'

// HEADER
useHead({
  title: 'Laser Marking and Engraving',
  meta: [
    {
      name: 'description',
      content: 'Custom laser marking and etching for multiple applications'
    }
  ]
})
</script>

<template>
  <section class="p-2 lg:p-6 surface-section border-round">
    <div class="grid">
      <div class="col-12 text-center">
        <h1 class="text-3xl md:text-5xl text-red-500 font-medium m-0 p-0">
          Laser Marking and Engraving available for you and your customers.
        </h1>
        <p class="text-xl">
          Industrial and governmental regulations requiring legible, permanent markings for identification and
          traceability are increasing.
        </p>
      </div>
      <div class="col-12 lg:col-8">
        <div class="text-2xl text-primary">
          Applications for Permanent Markings
        </div>
        <p>
          Daughtridge Sales offers laser marking and etching for multiple applications including:
        </p>

        <h4 class="text-primary-800 mb-0">
          Stainless steel tags
        </h4>
        <ul class="mt-1 mb-3">
          <li>Part identification #'s</li>
          <li>Part designation information</li>
          <li>Long lasting maintenance contact information</li>
        </ul>

        <h4 class="text-primary-800 mb-0">
          Information directly on parts
        </h4>
        <ul class="mt-1 mb-3">
          <li>Serial Numbers</li>
          <li>Part Numbers</li>
          <li>Company Logos</li>
          <li>End of Service Date</li>
        </ul>

        <h4 class="text-primary-800 mb-0">
          Most parts can have permanent markings made on them
        </h4>
        <ul class="mt-1 mb-3">
          <li>Steel Case Pressure Gauges</li>
          <li>Diaphragm Seals</li>
          <li>Hardware</li>
          <li>Connections</li>
          <li>Thermowells</li>
        </ul>

        <div class="text-2xl text-primary">
          Types of Permanent Markings
        </div>
        <p>
          The two primary ways of creating permanent markings are laser marking and etching.
        </p>
        <p>
          <strong class="text-primary-800">Laser Marking</strong> is when the laser beam interacts with the surface of a
          material, slightly altering its appearance.
        </p>
        <p>
          <strong class="text-primary-800">Laser Etching</strong> is when the laser beam removes layers from the surface
          of the material leaving an impression.
        </p>
      </div>
      <div class="col-12 lg:col-4">
        <div class="text-center mb-2">
          <img
            alt="Laser engraving on products"
            class="border-round w-full"
            src="/images/services/laser-marking-engraving.jpg"
            style="max-width: 600px;"
          >
        </div>
        <call-to-action
          text="Contact us to learn more or order Laser Marking and Engraving from Daughtridge Sales"
          :subject="subjects.LaserEngraving"
        />
      </div>
    </div>
  </section>
</template>
